import useChatAndUserData from "../hooks/useChatAndUserData";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import UserMessage from "../components/UserMessage";
import ChatbotMessage from "../components/ChatbotMessage";
import Grid from "@mui/material/Grid";

function MessageList() {
  const { chatData, loading } = useChatAndUserData();

  if (loading) {
    return <></>;
  }

  return (
    <MKBox py={2} sx={{ margin: "auto" }}>
      <Grid container spacing={2}>
        <Grid item xs={10} sx={{ margin: "auto" }}>
          {chatData.messages.map((message) =>
            message.sender === "user" ? (
              <UserMessage key={message.id} message={message} />
            ) : (
              <ChatbotMessage key={message.id} message={message} />
            )
          )}
        </Grid>
        {chatData.emailSent && (
          <Grid item xs={12}>
            <MKTypography variant="body2" align="center" py={2}>
              <strong>E-mail verzonden naar Willy Woef.</strong>
            </MKTypography>
          </Grid>
        )}
      </Grid>
    </MKBox>
  );
}

export default MessageList;
